"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInvitesSecondaryNavItems = exports.getInvitesNavItems = void 0;
require("core-js/modules/es.array.concat.js");
var _navConstants = require("../constants/navConstants");
var _navIcons = require("../constants/navIcons");
var _insertInArrayIf = _interopRequireDefault(require("../util/insertInArrayIf"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Used in web-preauth, web-wedding
 */

var paperAddOnsUrl = '/wedding-planning/paper-add-ons/shop';
var parent = _navConstants.PrimaryNavIdentifier.PAPER;
var businessUnit = 'PAPER';
var DIY_TITLE = 'Upload your own';
var DIY_PATHS = {
  std: '/wedding-planning/save-the-date/f945da1a-1ff5-4af0-a435-db9babd384d7',
  dstd: '/wedding-planning/digital/save-the-date/b997bd5a-8edf-4f3c-af88-ddeef3f1063e',
  invitations: '/wedding-planning/invitations/afe11498-7506-4d03-b30f-d7a024c91afa',
  enclosures: '/wedding-planning/enclosures/5d81bc54-c107-4be1-8f68-78cd18d7f2e6',
  programs: '/wedding-planning/programs/2fa8311b-3caa-40d0-91a9-6485228dde1f',
  menus: '/wedding-planning/menus/3638e408-8d1f-4cc1-9820-9fcefe9c2ced',
  ty: '/wedding-planning/thank-you-cards/1377423f-52a0-4aa7-bb25-144a449e3394',
  holiday: '/wedding-planning/holiday-cards/00ee44ef-238b-478b-b413-d518313bee88'
};
var getInvitesSecondaryNavItems = exports.getInvitesSecondaryNavItems = function getInvitesSecondaryNavItems(userContext) {
  var draftsAndOrders = {
    path: '/wedding-planning/projects/drafts',
    title: 'Drafts and orders',
    id: _navConstants.SecondaryNavIdentifier.PAPER_DRAFTS_AND_ORDERS,
    parent: parent,
    businessUnit: businessUnit
  };
  var shopUniversal = {
    path: '/wedding-planning/universal',
    title: 'Shop invites and paper',
    id: _navConstants.SecondaryNavIdentifier.PAPER_SHOP,
    parent: parent,
    businessUnit: businessUnit
  };
  var favorites = {
    path: '/favorites/paper',
    title: 'Favorites',
    id: _navConstants.SecondaryNavIdentifier.YOUR_FAVORITES,
    parent: parent,
    businessUnit: businessUnit
  };
  return [shopUniversal].concat(_toConsumableArray((0, _insertInArrayIf.default)(!!userContext.has_invitation_account, draftsAndOrders)), [favorites]);
};
var getInvitesNavItems = exports.getInvitesNavItems = function getInvitesNavItems(params) {
  var _params$forTertiaryNa = params.forTertiaryNav,
    forTertiaryNav = _params$forTertiaryNa === void 0 ? false : _params$forTertiaryNa,
    _params$hideNav = params.hideNav,
    hideNav = _params$hideNav === void 0 ? false : _params$hideNav,
    _params$isMobile = params.isMobile,
    isMobile = _params$isMobile === void 0 ? false : _params$isMobile,
    _params$showHolidayCa = params.showHolidayCards,
    showHolidayCards = _params$showHolidayCa === void 0 ? false : _params$showHolidayCa,
    enabledNewPaper = params.enabledNewPaper;
  if (hideNav) {
    return [];
  }

  /*
   * STD secondary nav items
   */
  var magnetSTD = {
    path: '/wedding-planning/save-the-date/shop?features=magnet',
    title: 'Magnet save the dates',
    businessUnit: businessUnit
  };
  var samplesSTD = {
    path: '/wedding-planning/save-the-date/shop?multi_sample_mode=multisampleenabled',
    title: 'Samples',
    businessUnit: businessUnit
  };
  var floralSTD = {
    path: '/wedding-planning/save-the-date/shop/floral',
    title: 'Floral',
    businessUnit: businessUnit
  };
  var modernSTD = {
    path: '/wedding-planning/save-the-date/shop/modern',
    title: 'Modern',
    businessUnit: businessUnit
  };
  var rusticSTD = {
    path: '/wedding-planning/save-the-date/shop/rustic',
    title: 'Rustic',
    businessUnit: businessUnit
  };
  var elegantSTD = {
    path: '/wedding-planning/save-the-date/shop/elegant_formal',
    title: 'Elegant',
    businessUnit: businessUnit
  };
  var simpleSTD = {
    path: '/wedding-planning/save-the-date/shop/simple_minimalist',
    title: 'Simple & minimalist',
    businessUnit: businessUnit
  };
  var classicSTD = {
    path: '/wedding-planning/save-the-date/shop/classic_traditional',
    title: 'Classic',
    businessUnit: businessUnit
  };
  var foilSTD = {
    path: '/wedding-planning/save-the-date/shop?features=foil',
    title: 'Foil',
    businessUnit: businessUnit
  };
  var letterpressSTD = {
    path: '/wedding-planning/save-the-date/shop?is_letterpress=is_letterpress',
    title: 'Letterpress',
    businessUnit: businessUnit
  };
  var newArrivalSTD = {
    path: '/wedding-planning/save-the-date/shop?sorts=launch_date',
    title: 'New arrivals',
    businessUnit: businessUnit
  };
  var bestSellersSTD = {
    path: '/wedding-planning/save-the-date/shop?sorts=popularity',
    title: 'Best sellers',
    businessUnit: businessUnit
  };
  var withPhotoSTD = {
    path: '/wedding-planning/save-the-date/shop?sorts=popularity&features=customphoto',
    title: 'Designs with photos',
    businessUnit: businessUnit
  };
  var diySTD = {
    path: DIY_PATHS.std,
    title: DIY_TITLE,
    businessUnit: businessUnit
  };

  /*
   * INV secondary nav items
   */
  var samplesINV = {
    path: '/wedding-planning/invitations/shop?multi_sample_mode=multisampleenabled',
    title: 'Samples',
    businessUnit: businessUnit
  };
  var floralINV = {
    path: '/wedding-planning/invitations/shop/floral',
    title: 'Floral',
    businessUnit: businessUnit
  };
  var modernINV = {
    path: '/wedding-planning/invitations/shop/modern',
    title: 'Modern',
    businessUnit: businessUnit
  };
  var rusticINV = {
    path: '/wedding-planning/invitations/shop/rustic',
    title: 'Rustic',
    businessUnit: businessUnit
  };
  var elegantINV = {
    path: '/wedding-planning/invitations/shop/elegant_formal',
    title: 'Elegant',
    businessUnit: businessUnit
  };
  var simpleINV = {
    path: '/wedding-planning/invitations/shop/simple_minimalist',
    title: 'Simple & minimalist',
    businessUnit: businessUnit
  };
  var classicINV = {
    path: '/wedding-planning/invitations/shop/classic_traditional',
    title: 'Classic',
    businessUnit: businessUnit
  };
  var foilINV = {
    path: '/wedding-planning/invitations/shop?features=foil',
    title: 'Foil',
    businessUnit: businessUnit
  };
  var letterpressINV = {
    path: '/wedding-planning/invitations/shop?is_letterpress=is_letterpress',
    title: 'Letterpress',
    businessUnit: businessUnit
  };
  var newArrivalINV = {
    path: '/wedding-planning/invitations/shop?sorts=launch_date',
    title: 'New arrivals',
    businessUnit: businessUnit
  };
  var bestSellersINV = {
    path: '/wedding-planning/invitations/shop?sorts=popularity',
    title: 'Best sellers',
    businessUnit: businessUnit
  };
  var featuredArtistsINV = {
    path: '/wedding-planning/invitations/shop?featuredArtists=featuredArtist',
    title: 'Featured artists',
    businessUnit: businessUnit
  };
  var withPhotoINV = {
    path: '/wedding-planning/invitations/shop?sorts=popularity&features=customphoto',
    title: 'Designs with photos',
    businessUnit: businessUnit
  };
  var diyINV = {
    path: DIY_PATHS.invitations,
    title: DIY_TITLE,
    businessUnit: businessUnit
  };
  var matchingSuites = {
    path: '/wedding-planning/suites/shop',
    title: 'Matching suites',
    id: forTertiaryNav ? _navConstants.TertiaryNavIdentifier.COLLECTIONS_PAPER : _navConstants.SecondaryNavIdentifier.MATCHING_SUITES,
    parent: parent,
    businessUnit: businessUnit
  };
  var matchingSuitesFeaturedArtists = {
    path: '/wedding-planning/suites/shop?featuredArtists=featuredArtist',
    title: 'Our featured artists',
    id: forTertiaryNav ? _navConstants.TertiaryNavIdentifier.COLLECTIONS_PAPER : _navConstants.SecondaryNavIdentifier.MATCHING_SUITES,
    parent: parent,
    businessUnit: businessUnit
  };
  var newArrivals = {
    path: '/wedding-planning/invitations/shop?sorts=launch_date',
    title: 'New arrivals',
    businessUnit: businessUnit
  };
  var stampedFoil = {
    path: '/wedding-planning/invitations/shop?features=foil',
    title: 'Stamped foil',
    businessUnit: businessUnit
  };
  var letterpress = {
    path: '/wedding-planning/invitations/shop?is_letterpress=is_letterpress',
    title: 'Letterpress',
    businessUnit: businessUnit
  };
  var arched = {
    path: '/wedding-planning/invitations/shop/arch',
    title: 'Arched',
    businessUnit: businessUnit
  };
  var saveTheDate = {
    path: '/wedding-planning/save-the-date/shop',
    title: 'Save the dates',
    id: forTertiaryNav ? _navConstants.TertiaryNavIdentifier.SAVE_THE_DATE : _navConstants.SecondaryNavIdentifier.SAVE_THE_DATE,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'SAVE_THE_DATE'
  };
  var paperAddOns = {
    path: paperAddOnsUrl,
    title: 'Paper add-ons',
    id: _navConstants.TertiaryNavIdentifier.PAPER_ADD_ONS,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'PAPER_ADD_ONS'
  };
  var bellyBands = {
    path: "/wedding-planning/paper-add-ons/shop?card_type=".concat(_navConstants.TertiaryNavIdentifier.BELLY_BANDS),
    title: 'Belly bands',
    id: _navConstants.TertiaryNavIdentifier.BELLY_BANDS,
    parent: parent,
    businessUnit: businessUnit
  };
  var vellumJackets = {
    path: "/wedding-planning/paper-add-ons/shop?card_type=".concat(_navConstants.TertiaryNavIdentifier.VELLUM_JACKETS),
    title: 'Vellum jackets',
    id: _navConstants.TertiaryNavIdentifier.VELLUM_JACKETS,
    parent: parent,
    businessUnit: businessUnit
  };
  var waxSeals = {
    path: "/wedding-planning/paper-add-ons/shop?card_type=".concat(_navConstants.TertiaryNavIdentifier.WAX_SEALS),
    title: 'Wax seals',
    id: _navConstants.TertiaryNavIdentifier.WAX_SEALS,
    parent: parent,
    businessUnit: businessUnit
  };
  var invitations = {
    path: '/wedding-planning/invitations/shop',
    title: isMobile ? 'Invitations' : 'Invites',
    id: forTertiaryNav ? _navConstants.TertiaryNavIdentifier.INVITATIONS : _navConstants.SecondaryNavIdentifier.INVITATION,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'INVITATIONS'
  };
  var weddingShowerTertiaryId = isMobile ? _navConstants.TertiaryNavIdentifier.WEDDING_SHOWER_INVITATION : _navConstants.TertiaryNavIdentifier.INVITATIONS;
  var weddingShower = {
    path: '/wedding-planning/bridal-shower/shop',
    title: 'Shower invitations',
    id: forTertiaryNav ? weddingShowerTertiaryId : _navConstants.SecondaryNavIdentifier.WEDDING_SHOWER_INVITATION,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'WEDDING_SHOWER_INVITATION'
  };
  var enclosureCardsTertiaryId = isMobile ? _navConstants.TertiaryNavIdentifier.ENCLOSURE : _navConstants.TertiaryNavIdentifier.INVITATIONS;
  var enclosureCards = {
    path: '/wedding-planning/enclosures/shop',
    title: isMobile ? 'Enclosure cards' : 'Enclosures',
    id: forTertiaryNav ? enclosureCardsTertiaryId : _navConstants.SecondaryNavIdentifier.DETAILS,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'ENCLOSURE'
  };
  var placeCardsTertiaryId = isMobile ? _navConstants.TertiaryNavIdentifier.PLACE : _navConstants.TertiaryNavIdentifier.DAY_OF;
  var placeCards = {
    path: '/wedding-planning/place-cards/shop',
    title: 'Place cards',
    id: forTertiaryNav ? placeCardsTertiaryId : _navConstants.SecondaryNavIdentifier.PLACE,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'PLACE'
  };
  var tableNumber = {
    path: '/wedding-planning/table-numbers/shop',
    title: 'Table numbers',
    id: forTertiaryNav ? _navConstants.TertiaryNavIdentifier.DAY_OF : _navConstants.SecondaryNavIdentifier.TABLE_NUMBER,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'TABLE_NUMBER'
  };
  var menusTertiaryId = isMobile ? _navConstants.TertiaryNavIdentifier.MENU : _navConstants.TertiaryNavIdentifier.DAY_OF;
  var menus = {
    path: '/wedding-planning/menus/shop',
    title: 'Menus',
    id: forTertiaryNav ? menusTertiaryId : _navConstants.SecondaryNavIdentifier.MENU,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'MENU'
  };
  var programsTertiaryId = isMobile ? _navConstants.TertiaryNavIdentifier.PROGRAM : _navConstants.TertiaryNavIdentifier.DAY_OF;
  var programs = {
    path: '/wedding-planning/programs/shop',
    title: 'Programs',
    id: forTertiaryNav ? programsTertiaryId : _navConstants.SecondaryNavIdentifier.PROGRAM,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'PROGRAM'
  };
  var napkinsTertiaryId = isMobile ? _navConstants.TertiaryNavIdentifier.NAPKIN : _navConstants.TertiaryNavIdentifier.DAY_OF;
  var napkins = {
    path: '/wedding-planning/napkins/shop',
    title: 'Napkins',
    id: forTertiaryNav ? napkinsTertiaryId : _navConstants.SecondaryNavIdentifier.NAPKIN,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'NAPKIN',
    newTag: true
  };
  var signageTertiaryId = isMobile ? _navConstants.TertiaryNavIdentifier.SIGNAGE : _navConstants.TertiaryNavIdentifier.DAY_OF;
  var signage = {
    path: '/wedding-planning/signage/shop',
    title: 'Signage',
    id: forTertiaryNav ? signageTertiaryId : _navConstants.SecondaryNavIdentifier.SIGNAGE,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'SIGNAGE',
    newTag: true
  };
  var stickersTertiaryId = isMobile ? _navConstants.TertiaryNavIdentifier.STICKER : _navConstants.TertiaryNavIdentifier.DAY_OF;
  var stickers = {
    path: '/wedding-planning/stickers/shop',
    title: 'Stickers',
    id: forTertiaryNav ? stickersTertiaryId : _navConstants.SecondaryNavIdentifier.STICKER,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'STICKER',
    newTag: true
  };
  var thankYouCards = {
    path: '/wedding-planning/thank-you-cards/shop',
    title: isMobile ? 'Thank you cards' : 'Thank yous',
    id: forTertiaryNav ? _navConstants.TertiaryNavIdentifier.THANK_YOUS : _navConstants.SecondaryNavIdentifier.THANK_YOU,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'THANK_YOU'
  };
  var digitalSaveTheDate = {
    path: '/wedding-planning/digital/save-the-date/shop',
    title: 'Digital save the dates',
    id: forTertiaryNav ? _navConstants.TertiaryNavIdentifier.DIGITAL_SAVE_THE_DATE : _navConstants.SecondaryNavIdentifier.DIGITAL_SAVE_THE_DATE,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'DIGITAL_SAVE_THE_DATE'
  };
  var albums = {
    title: 'Albums',
    path: '/wedding-albums/shop',
    id: forTertiaryNav ? _navConstants.TertiaryNavIdentifier.ALBUMS : _navConstants.SecondaryNavIdentifier.ALBUMS_SHOP,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'ALBUM'
  };
  var holiday = {
    title: isMobile ? 'Holiday cards' : 'Holiday',
    path: '/wedding-planning/holiday-cards/shop',
    id: forTertiaryNav ? _navConstants.TertiaryNavIdentifier.HOLIDAY : _navConstants.SecondaryNavIdentifier.HOLIDAY,
    icon: _navIcons.GIFT_ICON_RED,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'HOLIDAY'
  };
  var paperAddOnsChildren = [waxSeals, vellumJackets, bellyBands];
  var matchingCollectionsParent = _objectSpread(_objectSpread({}, matchingSuites), {}, {
    title: 'Collections',
    children: [{
      title: '',
      path: '',
      children: [matchingSuites, matchingSuitesFeaturedArtists]
    }, {
      title: '',
      path: '',
      children: [newArrivals, stampedFoil, letterpress, arched]
    }],
    showCaret: true
  });
  var saveTheDatesParent = _objectSpread(_objectSpread({}, saveTheDate), {}, {
    children: [{
      title: 'Category',
      path: '/wedding-planning/save-the-date/shop',
      children: [saveTheDate, digitalSaveTheDate, magnetSTD, samplesSTD, diySTD]
    }, {
      title: 'Styles',
      path: '/wedding-planning/save-the-date/shop/floral',
      children: [modernSTD, rusticSTD, floralSTD, elegantSTD, simpleSTD, classicSTD]
    }, {
      title: 'Premium',
      path: '/wedding-planning/save-the-date/shop?features=foil',
      children: [foilSTD, letterpressSTD]
    }, {
      title: 'Collections',
      path: '/wedding-planning/save-the-date/shop?sorts=launch_date',
      children: [newArrivalSTD, bestSellersSTD, withPhotoSTD]
    }, {
      title: 'Add-ons',
      path: paperAddOnsUrl,
      children: paperAddOnsChildren
    }],
    showCaret: true
  });
  var invitationsParent = _objectSpread(_objectSpread({}, invitations), {}, {
    children: [{
      title: 'Category',
      path: '/wedding-planning/invitations/shop',
      children: [_objectSpread(_objectSpread({}, invitations), {}, {
        title: 'Wedding invitations'
      }), weddingShower, enclosureCards, samplesINV, diyINV]
    }, {
      title: 'Styles',
      path: '/wedding-planning/invitations/shop/floral',
      children: [floralINV, modernINV, rusticINV, elegantINV, simpleINV, classicINV]
    }, {
      title: 'Premium',
      path: '/wedding-planning/invitations/shop?features=foil',
      children: [foilINV, letterpressINV]
    }, {
      title: 'Collections',
      path: '/wedding-planning/invitations/shop?sorts=launch_date',
      children: [newArrivalINV, bestSellersINV, featuredArtistsINV, withPhotoINV]
    }, {
      title: 'Add-ons',
      path: paperAddOnsUrl,
      children: paperAddOnsChildren
    }],
    showCaret: true,
    centerDropdown: true
  });

  // New paper types. Remove once all feature flags are enabled.
  var showNapkins = !!(enabledNewPaper !== null && enabledNewPaper !== void 0 && enabledNewPaper.napkins);
  var showSignage = !!(enabledNewPaper !== null && enabledNewPaper !== void 0 && enabledNewPaper.signage);
  var showStickers = !!(enabledNewPaper !== null && enabledNewPaper !== void 0 && enabledNewPaper.stickers);
  var dayOfParent = {
    path: '/wedding-planning/day-of',
    title: 'Day-of',
    id: forTertiaryNav ? _navConstants.TertiaryNavIdentifier.DAY_OF : _navConstants.SecondaryNavIdentifier.DAY_OF,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'DAY_OF',
    children: [{
      title: 'Paper',
      path: '/wedding-planning/day-of',
      businessUnit: businessUnit,
      businessCategory: 'DAY_OF',
      children: [placeCards, tableNumber, menus, programs].concat(_toConsumableArray((0, _insertInArrayIf.default)(showNapkins, napkins)), _toConsumableArray((0, _insertInArrayIf.default)(showSignage, signage)), _toConsumableArray((0, _insertInArrayIf.default)(showStickers, stickers)))
    }, {
      title: 'Boutique',
      path: '/shop/category/wedding-shop',
      businessUnit: 'REGISTRY',
      children: [{
        title: 'Gifts & favors',
        path: '/shop/category/wedding-gifts-favors',
        businessUnit: 'REGISTRY'
      }, {
        title: 'Party supplies & decor',
        path: '/shop/category/party-supplies-decor',
        businessUnit: 'REGISTRY'
      }, {
        title: 'Wedding party',
        path: '/shop/category/wedding-party-attire ',
        businessUnit: 'REGISTRY'
      }, {
        title: 'Accessories',
        path: '/shop/category/wedding-shop-accessories',
        businessUnit: 'REGISTRY'
      }]
    }],
    showCaret: true
  };
  var diyParent = {
    path: DIY_PATHS.std,
    title: DIY_TITLE,
    id: forTertiaryNav ? _navConstants.TertiaryNavIdentifier.DIY : _navConstants.SecondaryNavIdentifier.DIY,
    parent: parent,
    businessUnit: businessUnit,
    businessCategory: 'SAVE_THE_DATE',
    // Leads to a std PDP
    children: [_objectSpread(_objectSpread({}, saveTheDate), {}, {
      path: DIY_PATHS.std
    }), _objectSpread(_objectSpread({}, invitations), {}, {
      path: DIY_PATHS.invitations,
      title: 'Wedding invitations'
    }), _objectSpread(_objectSpread({}, enclosureCards), {}, {
      path: DIY_PATHS.enclosures
    }), _objectSpread(_objectSpread({}, programs), {}, {
      path: DIY_PATHS.programs
    }), _objectSpread(_objectSpread({}, menus), {}, {
      path: DIY_PATHS.menus
    }), _objectSpread(_objectSpread({}, thankYouCards), {}, {
      path: DIY_PATHS.ty
    }), _objectSpread(_objectSpread({}, holiday), {}, {
      path: DIY_PATHS.holiday
    })],
    showCaret: true
  };
  var freeSamplesParent = {
    path: '/wedding-planning/save-the-date/shop?multi_sample_mode=multisampleenabled',
    title: 'Free samples',
    id: forTertiaryNav ? _navConstants.TertiaryNavIdentifier.FREE_SAMPLES : _navConstants.SecondaryNavIdentifier.FREE_SAMPLES,
    parent: parent,
    businessUnit: businessUnit,
    children: [{
      title: 'Save the dates',
      path: '/wedding-planning/save-the-date/shop?multi_sample_mode=multisampleenabled',
      businessUnit: businessUnit
    }, {
      title: 'Invites',
      path: '/wedding-planning/invitations/shop?multi_sample_mode=multisampleenabled',
      businessUnit: businessUnit
    }],
    showCaret: true
  };
  var paperAddOnsParent = _objectSpread(_objectSpread({}, paperAddOns), {}, {
    children: paperAddOnsChildren,
    showCaret: true
  });
  if (isMobile) {
    return [saveTheDate, invitations, weddingShower, enclosureCards, menus, programs, tableNumber, placeCards, thankYouCards].concat(_toConsumableArray((0, _insertInArrayIf.default)(!!showHolidayCards, holiday)), _toConsumableArray((0, _insertInArrayIf.default)(showNapkins, napkins)), _toConsumableArray((0, _insertInArrayIf.default)(showSignage, signage)), _toConsumableArray((0, _insertInArrayIf.default)(showStickers, stickers)), [paperAddOns, digitalSaveTheDate]);
  }
  return [matchingCollectionsParent, saveTheDatesParent, invitationsParent, dayOfParent, thankYouCards].concat(_toConsumableArray((0, _insertInArrayIf.default)(!!showHolidayCards, holiday)), [paperAddOnsParent, albums, diyParent, freeSamplesParent]);
};